<template>
    <div class="bg-black pt-10 lg:pt-4">
        <div class="page md:flex">
            <div class="text-white" id="cc">
                <p class="title text-blue">聯絡我們</p>
                <p class="text-white mb-2">CONTACT US</p>
                <div class="leading-8 mt-10 mr-10">
                    <p class="font-bold leading-8">優兔數位有限公司</p>
                    <a
                        class="leading-7 md:leading-8 hover:underline"
                        href="https://maps.google.com/maps?ll=25.041154,121.578971&z=16&t=m&hl=zh-TW&gl=US&mapclient=embed&cid=145897544569221075"
                    >
                        台北市大安區忠孝東路四段270號5樓之2
                    </a>
                    <br />
                    <a
                        class="
                            leading-7
                            md:leading-8
                            hover:underline
                            underline
                            md:no-underline
                        "
                        href="tel:0227277282"
                    >
                        02-2727-7282
                    </a>
                    <br />
                    <a
                        class="
                            leading-7
                            md:leading-8
                            underline
                            md:no-underline
                            hover:underline
                        "
                        href="mailto:hello@jubbit.com.tw"
                    >
                        hello@jubbit.com.tw
                    </a>
                    <a
                        class="
                            leading-7
                            md:leading-8
                            hover:underline
                            text-red-400
                        "
                        href="https://www.facebook.com/hellojubbit"
                        target="_blank"
                    >
                        <div class="fb-icon mt-2"></div>
                    </a>
                </div>

                <div class="flex max-w-lg mt-4">
                    <div>
                        <a
                            href="https://www.facebook.com/business/partner-directory/details?solution_type=campaign_management&id=792315604928291&section=overview"
                            target="_blank"
                        >
                            <img src="/images/corp_1.png" />
                        </a>
                    </div>
                    <div><img src="/images/corp_2.png" /></div>
                    <div>
                        <a
                            href="https://pages.lazada.sg/wow/i/sg/smp/cb-landing"
                            target="_blank"
                        >
                            <img src="/images/corp_3.png" />
                        </a>
                    </div>
                    <div><img src="/images/corp_4.png" /></div>
                    <div><img src="/images/corp_5.png" /></div>
                </div>
            </div>
            <div class="pr-1 mt-6 md:mt-0 lg:pl-10 flex-1">
                <div class="w-full h-full">
                    <iframe
                        width="100%"
                        height="350px"
                        style="border: 0"
                        loading="lazy"
                        allowfullscreen
                        referrerpolicy="no-referrer-when-downgrade"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317.73586593478007!2d121.55486866362573!3d25.04098567823!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442abc66fbf65d7%3A0x479a78cddb1e1dff!2zMTA25Y-w5YyX5biC5aSn5a6J5Y2A5b-g5a2d5p2x6Lev5Zub5q61Mjcw6Jmf!5e0!3m2!1szh-TW!2stw!4v1752466488606!5m2!1szh-TW!2stw"
                    ></iframe>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import animate from './../../animate';
export default {
    mounted() {
        new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    animate('#cc', 'fadeInLeft');
                }
            });
        }).observe(document.getElementById('cc'));
    },
};
</script>
